import { type EdgeProps, getSmoothStepPath, BaseEdge } from "reactflow";

export default function DependencyEdge({
  id,
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
  ...props
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 24,
  });

  return (
    <BaseEdge
      {...props}
      id={id}
      path={edgePath}
      labelX={labelX}
      labelY={labelY}
      style={{
        stroke: "#bbb",
        strokeWidth: 1.5,
      }}
    />
  );
}
